import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingMortgageSection } from 'shared/components/NewbuildingMortgageSection';
import { useNewbuildingMortgageCalculatorMicrofront } from 'shared/hooks/useNewbuildingMortgageCalculatorMicrofront';
import { selectIsMortgageBrokerBannerAvailable } from 'shared/selectors/mortgageBroker';

export const NewbuildingMortgageCalculatorMicrofrontContainer: React.FC = () => {
  const isMortgageBrokerBannerAvailable = useSelector(selectIsMortgageBrokerBannerAvailable);
  const { isAvailable, manifest } = useNewbuildingMortgageCalculatorMicrofront();

  if (!isAvailable || isMortgageBrokerBannerAvailable) {
    return null;
  }

  return (
    <NewbuildingMortgageSection showHeader={false} header="">
      <div>
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
        />
      </div>
    </NewbuildingMortgageSection>
  );
};
